//AUTH
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';
export const EMAIL_VERIFIED = 'EMAIL_VERIFIED';
export const LOGOUT = 'LOGOUT';
export const USERS_FOUND = 'USERS_FOUND';
export const UPDATE_USER_LIST = 'UPDATE_USER_LIST';

//MESSAGES
export const SET_MESSAGE = 'SET_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

//TRACKING
export const USER_FOUND = 'USER_FOUND';
export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const CHECKED_IN = 'CHECKED_IN';
export const CHECKOUT_OUT = 'CHECKED_OUT';
export const LIST_CHECKED_IN_USERS = 'LIST_CHECKED_IN_USERS';
export const K12GROUP_CHECKED_IN = 'K12GROUP_CHECKED_IN';
export const CSV_DATA_LOADED = 'CSV_DATA_LOADED';
export const CSV_DATA_UNLOADED = 'CSV_DATA_UNLOADED';
export const CSV_DATA_DELETED = 'CSV_DATA_DELETED';

//RESOURCE CALENDAR
export const SET_RESOURCES = 'SET_RESOURCES';
export const SET_RESERVATIONS = 'SET_RESERVATIONS';
export const ADD_RESOURCE_EVENT = 'ADD_RESOURCE_EVENT';
export const REMOVE_RESOURCE_EVENT = 'REMOVE_RESOURCE_EVENT';
export const RESOURCE_UPDATED = 'RESOURCE_UPDATED';
export const RESOURCE_REMOVED = 'RESOURCE_REMOVED';
export const LAB_HOURS_GOT = 'LAB_HOURS_GOT';
export const LAB_HOURS_SET = 'LAB_HOURS_SET';

//BLOG
export const INIT_BLOG = 'INIT_BLOG';
export const ADD_BLOG = 'ADD_BLOG';
export const UPDATE_BLOG = 'UPDATE_BLOG';
export const REMOVE_BLOG = 'REMOVE_BLOG';
export const GET_BLOG = 'GET_BLOG';